require('../../modules/es6.math.trunc');
module.exports = require('../../modules/$.core').Math.trunc;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/trunc.js
// module id = 128
// module chunks = 2